import { useLang } from "@/lib/i18n";

export const Marquee = () => {
  const { c } = useLang();
  const row = [...c.MARQUEE_WORDS, ...c.MARQUEE_WORDS];
  return (
    <div data-testid="editorial-marquee" className="border-y border-line py-7 overflow-hidden bg-ink" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((w, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif italic text-2xl md:text-3xl text-dim/70 whitespace-nowrap px-8">{w}</span>
                <span className="text-gold text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
